import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/ui';
import { FormattedMessage } from 'react-intl';
import { Else, If, Then } from '@edikk-edikk/if';
import loadable from '@loadable/component';
import { useControls } from '#baseMenu/components/controls/middle-button/advert-contacts/hooks';

const AdvertContacts = loadable(() => import('@edikk-edikk/ui/advert/contacts/containers'), {
  resolveComponent: ({ AdvertContacts: AdvertContactsComponent }) => AdvertContactsComponent,
  ssr: false,
});

const ButtonAdvertContacts: FC = () => {
  const { isOpen, handlerClick } = useControls();

  return (
    <>
      <Button
        variant={isOpen ? ButtonVariant.white65 : ButtonVariant.black65}
        pill
        textUppercase
        onClick={handlerClick}
        additionalClassName="flex-grow-1"
      >
        <If condition={isOpen}>
          <Then>
            <FormattedMessage defaultMessage="Close" />
          </Then>
          <Else>
            <FormattedMessage defaultMessage="Contacts" />
          </Else>
        </If>
      </Button>
      <AdvertContacts />
    </>
  );
};

export { ButtonAdvertContacts };
